var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tabName == _vm.$parent.$data.selected)?_c('div',{staticClass:"pa-2"},[_vm._t("default",function(){return [_vm._v("content")]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }